module.exports = __webpack_public_path__ + "img/fig02.80299f8e.jpg";